import { lazy, memo } from "react";
import { Main } from "./Main";
import PageBaseline from "./PageBaseline";
import Sidebar from "../Sidebar";
import SkipToContent from "components/SkipToContent";
import { MAIN_CONTENT_ID } from "components/SkipToContent/SkipToContent";

const PDFReportDebugDialog = lazy(() => import("features/DashboardReports/components/PDFReportDebugPanel"));
const REACT_APP_DEBUG_PDF_GENERATOR = JSON.parse(process.env.REACT_APP_DEBUG_PDF_GENERATOR || "false");

const contentSx = REACT_APP_DEBUG_PDF_GENERATOR
  ? { width: "1098px!important", flex: "unset", border: "1px dashed pink" }
  : undefined;

interface PageContainerProps {
  children?: React.ReactNode;
}

function PageContainer(props: PageContainerProps) {
  return (
    <PageBaseline>
      <SkipToContent />
      <Sidebar />
      <Main id={MAIN_CONTENT_ID} sx={contentSx}>
        {props.children}
      </Main>
      <PDFReportDebugDialog />
    </PageBaseline>
  );
}

export default memo(PageContainer);
